import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the tablePagoPremioView.
 * @extends JetView
 */
export default class tablePagoPremioView extends JetView {
    /**
     * Configures the datatable view.
     * @returns {Object} Configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function

        return {
            view: 'datatable', // Type of view
            id: 'tablePagoPremio', // Unique identifier for the datatable
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            select: true, // Enable row selection
            columns: [
                // Column definitions
                {
                    id: 'Id', // Column ID
                    header: _('Ticket Det Id'), // Column header with localization
                    width: 100, // Column width
                    sort: 'int', // Sorting type
                },
                {
                    id: 'TicketId',
                    header: _('Ticket ID'),
                    width: 100,
                    sort: 'int',
                },
                {
                    id: 'Description',
                    header: _('Descripción'),
                    width: 200,
                    sort: 'int',
                },
                { id: 'Market', header: _('Market'), width: 100, sort: 'int' },
                { id: 'Option', header: 'Option', width: 200, sort: 'int' },
                {
                    id: 'Odds',
                    header: _('Odds'),
                    width: 100,
                    format: webix.i18n.numberFormat, // Formatting for odds
                    sort: 'int',
                },
            ],
            footer: true, // Enable footer
            math: true, // Enable mathematical operations in footer
            loadahead: devConfig.getDefaultDataFetch(), // Data fetching configuration
            pager: 'pagerA', // Pager ID for pagination
            url: devConfig.geturlApi() + 'Report/GetBetHistoryDetail', // API endpoint for data loading
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        $$('tablePagoPremio').hide(); // Hides the datatable initially

        // Event listener for filtering data based on ticket number
        this.on(this.app, 'pagoPremio:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filterData to an array of entries
            var string1 = '&id=' + filterData.NoTicket; // Construct query string for ticket ID
            console.log(string1); // Log the query string
            grid.load(
                // Load data into the grid
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + string1,
            );
        });

        // Event listener for item click to trigger user ID event
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get the clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Call event with user ID
        });

        // Event listener for player selection to filter data
        this.on(this.app, 'player:select', (Id) => {
            grid.load(
                // Load data into the grid based on selected player ID
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id,
            );
        });
    }
}

// FILE DOCUMENTED
